import {useContext} from 'react';
import {context as authContext} from 'utilities/auth';

export function useProtection() {
  const {isAuthenticated, signOut} = useContext(authContext);
  return {isAuthenticated, signOut};
}
